if(!customElements.get('bundle-builder')) {
  class BundleBuilder extends HTMLElement {
  	constructor() {
      super();

      var config = {
        bundleContainer: this, //bundle box selector
        items: document.querySelectorAll(this.dataset.itemsSelector), //items selector,
        bundleMinItems: parseInt(this.dataset.bundleMinItems), //global minimum required quantity of items in the bundle
        bundleMaxItems: parseInt(this.dataset.bundleMaxItems), //global limit of items in the bundle, 0=no limit
        groupItems: this.dataset.groupItems=='true', // true, or false to view 1 unit item,
        cartBundleMode: this.dataset.cartBundleMode, // "grouped" or "individual",
        showItemsPlaceholder: this.dataset.showItemsPlaceholder=='true',
        stepsContainer: document.querySelector(this.dataset.stepsContainerSelector),
        bd: this.dataset.bd
      }
      //nav & panels behavior
      var btnNavClickHandler = ()=>{};
      if (config.stepsContainer.dataset.navMode == 'step_by_step' || config.stepsContainer.dataset.navMode == 'show_tabs') {
        btnNavClickHandler = function() {
          var switchPanel = true;
          var oldActiveButton = config.stepsContainer.querySelector('.step-nav.active');
          var oldActiveStep = oldActiveButton.dataset.step/1;
          var newStep = this.dataset.step/1;
          if (this.classList.contains('active')) {
            //don't switch if it is the active panel;
            switchPanel = false;
          }
          if (switchPanel) {
            var oldActivePanel = config.stepsContainer.querySelector('.step.active');
            var newActivePanel = config.stepsContainer.querySelector('.step[data-step="'+newStep+'"]');
            oldActiveButton.classList.remove('active');
            oldActivePanel.classList.remove('active');
            this.classList.add('active');
            newActivePanel.classList.add('active');

          }
        }
      } else {
        btnNavClickHandler = function() {
          var newStep = this.dataset.step/1;
          var newActivePanel = config.stepsContainer.querySelector('.step[data-step="'+newStep+'"]');
          $s.scrollToElement(newActivePanel, 60);
        }
      }
      config.stepsContainer.querySelectorAll('.nav .step-nav').forEach(function(btn) {
        btn.addEventListener('click', btnNavClickHandler)
      });

      /* start of builder */
      var Bundler = (function(config) {
        var self = {};
        var container = config.bundleContainer;
        self.dataJson = JSON.parse(container.querySelector('[type="application/json"]').textContent);
        self.stats = {count: 0, total: 0, discount_code: '', incomplete_products_steps: self.dataJson.products_steps.map((x,key)=>key).filter(x=>x>0)};

        var itemsAdded = [];
        var uniqIndex = 1;
        var uniq = function() {
          return 'k-' + uniqIndex++;
        }
        var variantUnits = function(id, currentStep) {
          return itemsAdded.reduce((x,y)=>x + (id == y.variant_id && currentStep == y.step  ? y.quantity : 0), 0);
        }
        var productUnits = function(id, currentStep) {
          return itemsAdded.reduce((x,y)=>x + (id == y.product_id && currentStep == y.step ? y.quantity : 0), 0);
        }
        self.add = function(variantId, quantity, htmlItem) {
          var index = itemsAdded.map((x)=>x.variant_id).lastIndexOf(variantId);
          var item;
          if (config.groupItems && index != -1) {
            item = itemsAdded[index];
            item.quantity += quantity
          } else {
            var json = JSON.parse(htmlItem.querySelector('[type="application/json"]').textContent);
            item = {
              variant_id: variantId,
              quantity: quantity,
              key: uniq(),
              product_id: htmlItem.dataset.productId,
              title: htmlItem.querySelector('.title').innerText,
              image: htmlItem.querySelector('[tabindex="0"] .img.main').outerHTML,
              variant: json.variants.find((x)=>x.id==variantId), 
              productData: json,
              step: htmlItem.step
            };
            itemsAdded.push(item);
          }
          self.drawItem(item);
          
        }
        self.remove = function(variantId, removeQuantity, currentStep) {
          var index = itemsAdded.map((x)=>{return currentStep==x.step ? x.variant_id : 0}).lastIndexOf(variantId);
          self.removeByIndex(index, removeQuantity);
        }
        self.removeByKey = function(key) {
          var index = itemsAdded.findIndex((x)=>x.key==key);
          var item = itemsAdded[index];
          self.removeByIndex(index, item.quantity);
        }
        self.removeByIndex = function(index, removeQuantity) {
          var item = itemsAdded[index];
          item.quantity -= removeQuantity;
          if (item.quantity == 0) {
            itemsAdded.splice(index, 1);
          }
          self.drawItem(item);
        }
        self.drawItem = function(item) {
          var itemsContainer = container.querySelector('.bundle-items');
          var html = `
            <div class="bundle-item flex direction-column" data-key="${item.key}">
                <div class="image-wrapper">
                  <div class="image">${item.image}</div>
                </div>
                <div class="content-wrapper flex justify-content-between align-items-start">
                  <div class="text-wrapper">
                    <div class="variant-title heading-font">${item.variant.title}</div>
                    <div class="title heading-font">${item.title}</div>
                    <div class="bundle-swatch label-inner color-${$s.handleize(item.variant.title)}">&nbsp;</div>
                  </div>
                  <button class="remove" aria-label="Remove Item" title="Remove Item">
                    <svg aria-hidden="true" tabindex="-1" role="presentation" class="icon icon-close" viewBox="0 0 32 32"><path fill="#CDCCCC" d="m21,4h-3.37l-1.07-2.28c-.24-.52-.63-.95-1.11-1.25-.48-.3-1.04-.47-1.61-.47h-5.69c-.57,0-1.12.16-1.61.47-.48.31-.86.74-1.11,1.25l-1.07,2.28H1c-.55,0-1,.45-1,1s.45,1,1,1h1.11l1.48,13.33c.08.73.43,1.41.98,1.91.55.49,1.26.76,2,.76h8.86c.74,0,1.45-.27,2-.77.55-.5.9-1.17.98-1.9l1.48-13.33h1.1c.55,0,1-.45,1-1s-.45-1-1-1Zm-13.75-1.43c.08-.17.21-.32.37-.42.16-.1.35-.16.54-.16h5.69c.19,0,.38.05.54.16s.29.25.37.42l.67,1.43H6.58l.67-1.43Zm9.18,16.54c-.03.24-.14.47-.33.63-.18.17-.42.26-.67.26H6.57c-.25,0-.48-.09-.67-.25-.18-.16-.3-.39-.33-.64l-1.46-13.11h13.77l-1.46,13.11Zm-6.43-9.11v5c0,.55-.45,1-1,1s-1-.45-1-1v-5c0-.55.45-1,1-1s1,.45,1,1Zm4,0v5c0,.55-.45,1-1,1s-1-.45-1-1v-5c0-.55.45-1,1-1s1,.45,1,1Z"></path></svg>
                  </button>
                </div>                  
              </div>
            </div>
            `;
          var existingItem = itemsContainer.querySelector('[data-key="' + item.key + '"]');
          if (item.quantity == 0) {
            html = '';
          }
          if (existingItem) {
            existingItem.outerHTML = html;
          } else {
            itemsContainer.insertAdjacentHTML("beforeend", html);
            
          }
          if (html != '') {
            itemsContainer.querySelector('.bundle-item[data-key="' + item.key + '"] .remove').addEventListener('click', function() {
              self.removeByKey(item.key);
            });
          }

          self.updateUI(item.step);
        }
        self.drawFormInputs = function() {
          //TODO Subscription updates here (replace variant_id, set subscription properties or selling plan value)
          var html = ''
          var bundleId = new Date().getTime() + '-' + Math.floor(Math.random()*9999 + 1000);
          var bd = config.bd;
          var extra = self.dataJson.extra;
          //walk array in reverse order (then cart items order will match what user see in the bundler builder)

          var loopLength = extra ? itemsAdded.length : itemsAdded.length - 1;
          for (var index = loopLength; index>=0; index--) {
            var mode = config.cartBundleMode == 'grouped' ? (index==0?'main' : 'related_multiple') : 'individual';

            if(extra && index === loopLength){
              html += `<input type="hidden" name="items[${index}][id]" value="${extra}">
              <input type="hidden" name="items[${index}][properties[_bundle_id]]" value="${bundleId}">
              <input type="hidden" name="items[${index}][properties[_bundle_item]]" value="${mode}">
              <input type="hidden" name="items[${index}][properties[_bundle_gift]]" value="1">
              <input type="hidden" name="items[${index}][properties[_bundle_bd]]" value="${bd}">
              <input type="hidden" name="items[${index}][properties[_bundle_position]]" value="${index + 1}">
              <input type="hidden" name="items[${index}][quantity]" value="1">`
            }else{
              var item = itemsAdded[index];
              html += `<input type="hidden" name="items[${index}][id]" value="${item.variant_id}">
                <input type="hidden" name="items[${index}][properties[_bundle_id]]" value="${bundleId}">
                <input type="hidden" name="items[${index}][properties[_bundle_item]]" value="${mode}">
                <input type="hidden" name="items[${index}][properties[_bundle_bd]]" value="${bd}">
                <input type="hidden" name="items[${index}][quantity]" value="${item.quantity}">
                `;
              if (!config.groupItems) {
                html += `<input type="hidden" name="items[${index}][properties[_bundle_position]]" value="${index + 1}">`;                
              }
              if (extra) {
                html += `<input type="hidden" name="items[${index}][properties[_bundle_hasgift]]" value="1">`;                
              }
            }
          }
          
          container.querySelector('.form-inputs').innerHTML = html;
        }
        self.updateUI = function(currentStep, callback) {
          //TODO Subscription updates here (show discounted price, don't change the variant id)
          var itemsContainer = container.querySelector('.bundle-items');
          var totalCount = itemsAdded.reduce((x,y)=>x + y.quantity, 0);
          var totalPrice = itemsAdded.reduce((x,y)=>x + y.variant.price * y.quantity, 0);
          self.stats.count = totalCount;
          self.stats.total = totalPrice;
          self.stats.discounted_price = '';


          self.dataJson.products_steps.forEach(function(pd_step, stepIx) {
            var currentStep = stepIx + 1;
            var stepConfig = self.dataJson.products_steps[stepIx];
            var stepContainter = config.stepsContainer.querySelector('.step[data-step="'+currentStep+'"]')
            var itemsAddedFromStep = itemsAdded.filter(x=>x.step==currentStep);
            var totalCountInStep = itemsAddedFromStep.reduce((x,y)=>x + y.quantity, 0);
            if (stepContainter) {
              stepContainter.querySelectorAll('.selected-quantity').forEach(x=>x.innerHTML = totalCountInStep);
            }

            var incompleteStepsItemIndex = self.stats.incomplete_products_steps.indexOf(currentStep);
            if (stepConfig.min_items > 0 && totalCountInStep < stepConfig.min_items) {
              if (incompleteStepsItemIndex==-1) {
                self.stats.incomplete_products_steps.push(currentStep);
              }
            } else if (incompleteStepsItemIndex > -1) {
              self.stats.incomplete_products_steps.splice(incompleteStepsItemIndex, 1);
            }

            config.items.forEach(function(item) {
              if (item.step!=currentStep) {
                return;
              }
              //update number in quantity box (useful when removing items with the X)
              var currentVariantId = item.querySelector('[data-variant-id]').value;
              var currentVariantUnits = variantUnits(currentVariantId, currentStep);
              item.querySelector('input[type="number"]').value = currentVariantUnits;

              //disable/enable MINUS button
              item.querySelectorAll('.quantity-button.minus').forEach(function(element) {
                if (item.querySelector('[type="number"]').value == 0) {
                  element.setAttribute('disabled', true);
                } else {
                  element.removeAttribute('disabled');
                }
              });
              
              //disable/enable PLUS and ADD buttons
              item.querySelectorAll('.quantity-button.plus, .btn.add, .quick-view-bundle-trigger').forEach(function(element) {
                var variantInput = item.querySelector('[data-variant-id]')
                var productId = item.dataset.productId;
                if ( (config.bundleMaxItems > 0 && totalCount>=config.bundleMaxItems)
                  || (stepConfig.max_items > 0 && totalCountInStep>=stepConfig.max_items)
                  || (stepConfig.item_limit > 0 && variantUnits(variantInput.value, currentStep) >= stepConfig.item_limit)
                  || (stepConfig.product_limit > 0 && productUnits(productId, currentStep) >= stepConfig.product_limit) ) {
                  
                  if(element.classList.contains('quick-view-bundle-trigger')){
                    element.classList.add('btn-disabled')
                  } else {
                    element.setAttribute('disabled', true);
                  }
                } else {
                  if(element.classList.contains('quick-view-bundle-trigger')){
                    element.classList.remove('btn-disabled')
                  } else {
                    element.removeAttribute('disabled', true);
                  }
                }
              });
            });

          });

          
          
          //item placeholders
          if (config.showItemsPlaceholder) {
            itemsContainer.querySelectorAll('.item-placeholder').forEach(function(element) {
              element.parentNode.removeChild(element);
            });
            if (config.bundleMinItems > itemsAdded.length) {
              var placeholder = `
                <div class="bundle-item item-placeholder">
                  <div class="flex">
                    <div class="one-whole"><div class="info-placeholder"></div></div>
                  </div>
                </div>
                `.repeat(config.bundleMinItems - itemsAdded.length);
              itemsContainer.insertAdjacentHTML('beforeend', placeholder);
            }
          }
          
          //disable/enable ADD BUNDLE TO CART button if conditions not meet
          var enableAddBundle = true;
          if (self.stats.incomplete_products_steps.length > 0 || (config.bundleMinItems > 0 && totalCount < config.bundleMinItems)) {
            enableAddBundle = false;
          }
          if (enableAddBundle) {
            container.querySelector('.btn.add').removeAttribute('disabled');
          } else {
            container.querySelector('.btn.add').setAttribute('disabled', true);
          }


          //disable/enable step nav buttons after a step not completed
          if (config.stepsContainer.dataset.navMode == 'step_by_step') {
            var firstStepIncomplete = null;
            if (self.stats.incomplete_products_steps.length>0) {
              firstStepIncomplete = Math.min(...self.stats.incomplete_products_steps);
            }
            config.stepsContainer.querySelectorAll('.nav .step-nav').forEach(function(btn, ix) {
              if (firstStepIncomplete && ix+1 > firstStepIncomplete) {
                btn.setAttribute('disabled', true);
              } else {
                btn.removeAttribute('disabled');
              }
            });
          }


          self.updateProgress();
          
          container.querySelector('.count').innerHTML = totalCount;
          var finalPrice = self.stats.discounted_price ? self.stats.discounted_price : totalPrice;

          container.querySelector('.subtotal .price').innerHTML = `
            ` + (self.stats.discounted_price ? `<span class="retail money">` + $s.formatMoney(self.stats.total).replace('.00','') + `</span>` : ``) + `
            <span class="deal money">` + $s.formatMoney(finalPrice).replace('.00','') + `</span>
            `;

          callback 
        }

        self.updateProgress = function() {
          //progress bar UI
          if (self.dataJson.progress_steps.length > 0) {
            var steps = self.dataJson.progress_steps;
            var progressType = self.dataJson.progress_type;
            var currentValue = progressType == 'quantity' ? self.stats.count : self.stats.total/100;
            var values = steps.map((step)=>step.value);
            var maxValue = Math.max(...values);
            var completedCaption = container.querySelector('.progress-completed');
            var caption = container.querySelector('.progress-caption');

            var progressLongValue = container.querySelector('.progress-value');
            var progressBars = container.querySelectorAll('.progress-bar');

            if (self.dataJson.progress_steps_independent) {
              progressBars.forEach(function(progressBar, ix) {
                var progressValue = progressBar.querySelector('.progress-value');
                var barValue = Math.min(currentValue / values[ix] * 100, 100);
                progressValue.style.width = barValue + '%';
                var dot = progressBar.querySelector('.progress-dot');
                if (barValue==100) {
                  dot.classList.add('completed');
                } else {
                  dot.classList.remove('completed');
                }
              });
            } else {
              var barValue = Math.min(currentValue / maxValue * 100, 100);
              progressLongValue.style.width = barValue + '%';
              progressBars.forEach(function(progressBar, ix) {
                progressBar.style.width = (values[ix] - (ix==0 ? 0 : values[ix-1]) ) / maxValue * 100 + '%';
                var dot = progressBar.querySelector('.progress-dot');
                if (values[ix]<=currentValue) {
                  dot.classList.add('completed');
                } else {
                  dot.classList.remove('completed');
                }
              });
            }

            caption.innerHTML = '';
            completedCaption.innerHTML = '';
            var stepCompletedIndex = -1;
            for (var i=0; i<steps.length; i++) {
              var step = steps[i];
              if (currentValue < step.value) {
                //next step
                var diff = step.value - currentValue;
                caption.innerHTML = step.caption_step_in_progress
                  .replace('[CURRENT_VALUE]', (progressType=='quantity' ? currentValue : $s.formatMoney(currentValue * 100)) )
                  .replace('[VALUE_REQUIRED]', (progressType=='quantity' ? diff : $s.formatMoney(diff * 100)) );
                break;
              } else {
                stepCompletedIndex = i;
                completedCaption.innerHTML = step.caption_step_completed;
                self.stats.discount_code = step.discount_code || '';
                if (step.discount_percentage) {
                  self.stats.discounted_price = self.stats.total * (100 - step.discount_percentage) / 100;
                }
              }
            }            

          }
        }


        function init() {
          container.querySelector('.btn.add').addEventListener('click', function() {
            var add = ()=> {
              self.drawFormInputs();
              var data = new FormData();
              container.querySelector('.form-inputs').querySelectorAll('[name]:checked,[name]:not([type="checkbox"]):not([type="radio"])').forEach(x=>data.append(x.name, x.value));
              $s.post({
                url: '/cart/add.js',
                data: data,
                success: function(){
                  $s.addToCartSuccess();
                },
                error: function(response){
                  $s.addToCartFail(response.description);
                }
              })
            }
            
            $s.showLoadingOverlay();

            if (self.stats.discount_code) {
              $s.get({url: '/discount/'+self.stats.discount_code, success: add})
            } else {
              add();
            }
          });

          var expandButton = container.querySelector('.expand-button');

          // expandButton.addEventListener('click', function() {
          //   var panel = container.querySelector('.medium-down--expandable');
          //   if (this.getAttribute('aria-expanded')=='false') {
          //     this.setAttribute('aria-expanded', 'true');
          //     $s.expand([panel]);
          //   } else {
          //     this.setAttribute('aria-expanded', 'false');
          //     $s.collapse([panel]);
          //   }
          // });

          config.items.forEach(function(item) {
            //Update input type number starting value and min="0" attribute
            var a = item.querySelector('.product-card-url');
            a.removeAttribute('href');
            var number = item.querySelector('input[type="number"');
            var variantInput = item.querySelector('input[data-variant-id]');
            var addBtn = item.querySelector('.btn.add');
            item.step = item.closest('[data-step]').dataset.step/1;
            var currentStep = item.step;
            var stepConfig = self.dataJson.products_steps[currentStep-1];

            number.setAttribute('min', '0');
            number.value = 0;
            number.setAttribute('disabled', true);
            if (stepConfig.item_limit) {
              number.setAttribute('max', stepConfig.item_limit);
            }

            //Handle quantity change
            number.addEventListener('change', function(event) {
              var diff = this.value - variantUnits(variantInput.value, currentStep);
              if (diff > 0) {
                self.add(variantInput.value, diff, item);
              } else if (diff < 0) {
                self.remove(variantInput.value, Math.abs(diff), item.step);
              }
            });

            //Handle swatch change
            variantInput.addEventListener('change', function(event) {
              number.value = variantUnits(variantInput.value, currentStep);
              self.updateUI(currentStep);
            });

            //clear existing events and replace button
            var btnDisplay = addBtn.style.display;
            addBtn.outerHTML = '<button type="button" class="btn add large--hide" style="display: none">ADD TO SET</button>';
            //update internal reference;
            addBtn = item.querySelector('.btn.add');
            addBtn.style.display = btnDisplay;
            addBtn.addEventListener('click', function() {
              $s.showLoadingOverlay()
              self.add(variantInput.value, 1, item);
              number.value = variantUnits(variantInput.value, currentStep);
              self.updateUI(currentStep, setTimeout(() => {$s.hideLoadingOverlay()}, 500));              
            });

        
          })

          self.updateUI(1);
        }
        
        init();

        return self;
      })(config);


    }
  }
  customElements.define('bundle-builder', BundleBuilder);
}
